export default __webpack_public_path__ + "static/media/annam-reddy.efc55495.webp";